import React from "react";
import { DropdownSingle } from "oolib";
// Buttons aren't re-exported from the oolib root — they must come from this
// deep path, or they resolve to undefined at runtime.
import { ButtonGhost, ButtonPrimary } from "oolib/dist/v2/components/Buttons";

/**
 * Sheet-select step of the compact import flow (body only — rendered inside the
 * shared ImportModalShell, like the source-selection and add-data views).
 *
 * Only reached when a dropped workbook has more than one sheet; a single-sheet
 * file (and every CSV, which has no sheets at all) skips straight to upload.
 */
export const SheetSelectView = ({
  sheetNames,
  selectedSheetName,
  setSelectedSheetName,
  onConfirm,
  onGoBack,
}) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
    <DropdownSingle
      label="Sheet"
      saveValueAsString
      options={sheetNames.map((d) => ({ display: d, value: d }))}
      placeholder="Select A Sheet"
      value={selectedSheetName}
      onChange={(k, v) => setSelectedSheetName(v)}
    />
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.6rem" }}>
      <ButtonGhost onClick={onGoBack}>Go Back</ButtonGhost>
      <ButtonPrimary onClick={onConfirm} disabled={!selectedSheetName}>
        Continue
      </ButtonPrimary>
    </div>
  </div>
);

export default SheetSelectView;
